/**
 * VehicleRoadTax actions
 */
export enum VehicleRoadTaxActionEnum {
	/**
	 * Set road tax status to approved
	 */
	APPROVE = 'approve',

	/**
	 * Set road tax status to active
	 */
	ACTIVATE = 'activate',

	/**
	 * Set road tax status to rejected
	 */
	REJECT = 'reject',

	/**
	 * Set road tax status to pending
	 */
	PENDING = 'make_pending',

	/**
	 * Set road tax status to expired
	 */
	EXPIRE = 'expire',

	/**
	 * Submit the paid amount of the road tax
	 */
	PAY = 'pay',

	/**
	 * Set road tax status to expired
	 */
	EXPIRED = 'make_expired',
}
